var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('embed-viewer-route-view',{attrs:{"url":'https://www.youtube.com/embed/kMWxBpM-MSA?autoplay=1&modestbranding=1&playsinline=1',"title":_vm.$t('LearnMoreTitle'),"can-go-back":_vm.canGoBack}})}
var staticRenderFns = []

export { render, staticRenderFns }